/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const OAUTH_REDIRECT_FLOW_KEY = 'oAuthRedirectCodeFlow';
